import * as React from 'react';
import Button from "@mui/material/Button";
import {useEffect, useState, useCallback} from "react";
import {getAllStaffMembers} from "../../utilities/cvAPI";
import keycloak from "../../Keycloak";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import TableSortLabel from '@mui/material/TableSortLabel';
import {TextField, InputAdornment} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import Box from "@mui/material/Box";
import TableContainer from '@mui/material/TableContainer';
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';

const StaffMemberListView = () => {

    const style = {
        "& label.Mui-focused": {
            color: "#EC8D2B",
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#EC8D2B",
            },
        },
    };

    const tableHeaderStyle = {
        backgroundColor: '#DDDFDF',
        height: '56px',
    };

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: "#DDDFDF",
            color: theme.palette.common.black,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 15,
        },
    }));

    const typographyStyles = {
        backgroundColor: '#F3F3F3',
        height:'50px',
        '&:hover': {
            backgroundColor: '#F79016'
        },
    };

    localStorage.setItem("cv", -1);

    const buttonStyles = {
        color: 'black',
        '&:hover': {
            color: 'white',
            backgroundColor: 'Transparent'
        },
        width:'100%',
        height: '100%',
        justifyContent: 'flex-start',
        textTransform: 'none',
    };


    const [staffMemberDetails, setStaffMemberDetails] = useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('clientName');
    const [CV, setCV] = useState("");

    const columns = [
        { id: 'firstName', label: 'First name', minWidth: 100 },
        { id: 'surname', label: 'Surname', minWidth: 100 },
        { id: 'skills', label: 'Skills', minWidth: 100},
        { id: 'last/current company', label: 'Last / Current Company', minWidth: 200 },
        { id: 'webtonicProject', label: 'Webtonic Project', minWidth: 200},
        { id: 'startDate', label: 'Start Date', minWidth: 100},
        { id: 'endDate/currentDate', label: 'End / Current Date', minWidth: 100},
        { id: 'action', label: 'Action', minWidth: 75}
    ]

    const callGetAllStaffMembers = useCallback(() => getAllStaffMembersAndUpdateUI(), []);

    async function getAllStaffMembersAndUpdateUI() {
        if (keycloak) {
            try{
                let staffMembers = await getAllStaffMembers(keycloak.token)
                if(staffMembers) {
                    setStaffMemberDetails(staffMembers);
                    if (staffMembers.length > 0) {
                        StaffMemberListView.updateUIWithStaffMembers();
                    } else {
                        StaffMemberListView.updateUIWithoutStaffMembers();
                    }
                }}
                catch (e) {
                    StaffMemberListView.updateUIWithoutStaffMembers();
                }
        }
    }

    StaffMemberListView.updateUIWithStaffMembers = function() {
        document.getElementById("NoClientText").style.display = "none";
        document.getElementById("cvSearchBar").style.display = "block";
        document.getElementById("showClientsPaper").style.display = "block";
    }

    StaffMemberListView.updateUIWithoutStaffMembers = function() {
        document.getElementById("showClientsPaper").style.display = "none";
        document.getElementById("cvSearchBar").style.display = "none";
        document.getElementById("NoClientText").style.display = "block";
    }

    useEffect(() => {
        callGetAllStaffMembers();
    }, [callGetAllStaffMembers])

    const handleClick = (event, cv) => {
        setAnchorEl(event.currentTarget);
        setCV(cv);
    }

    const exportCV = () =>{

    }


    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleSortRequest = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
    };


    return (
        <div style={{padding:"20px 5%"}} data-testid='OuterGrid'>
            <div data-testid='InnerGrid'>
                <div className="row">
                    <div data-testid='clientListHeaderDiv' style={{marginBottom: "10px"}}>
                        <h2 data-testid='ClientHeading' className="AddStaffMemberListViewHeading d-inline-block" style={{ fontFamily: 'Poppins', fontWeight: '42px' }}>Staff Member List View</h2>

                        <div className={"ticketSearchBar"} id={"cvSearchBar"} data-testid='cvSearchBar'>
                            <TextField
                                data-testid="ticketSearchBar"
                                placeholder="Search..."
                                type="search"
                                sx={style}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </div>
                    </div>

                    <div id="NoClientText" className="NoClientText" data-testid='NoClientText'>You do not have any cv's.</div>
                </div>
                <Box id="showClientsPaper" data-testid='showClientsPaper'>
                    <TableContainer sx={{ maxHeight: 520, overflow: 'auto', borderRadius: "4px", boxShadow: "0px 0px 0px 1px #E0E0E0"}}>
                        <Table stickyHeader aria-label="sticky table" data-testid={"materialUITable"}>
                            <TableHead data-testid='tableHead'>
                                <TableRow style={tableHeaderStyle}>
                                    <StyledTableCell
                                        key={columns[0].id}
                                        align={columns[0].align}
                                        style={{ minWidth: columns[0].minWidth }}
                                        sortDirection={orderBy === columns[0].id ? order : false}
                                    >
                                        <TableSortLabel data-testid={"tableSort"}
                                            active={orderBy === columns[0].id}
                                            direction={orderBy === columns[0].id ? order : 'asc'}
                                            onClick={() => handleSortRequest(columns[0].id)}
                                        >
                                            {columns[0].label}
                                        </TableSortLabel>
                                    </StyledTableCell>
                                    {columns.slice(1).map((column) => (
                                        column.id === 'action' ?
                                            (
                                                <StyledTableCell
                                                    key={column.id}
                                                    align={"center"}
                                                    style={{ minWidth: column.minWidth }}
                                                >
                                                    {column.label}
                                                </StyledTableCell>
                                            )
                                            : (
                                                <StyledTableCell
                                                    key={column.id}
                                                    align={column.align}
                                                    style={{ minWidth: column.minWidth }}
                                                >
                                                    {column.label}
                                                </StyledTableCell>
                                            )
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody data-testid='tableBody'>
                                {staffMemberDetails.map((client, index) => (
                                    <TableRow data-testid='tableRow' key={index} style ={ index % 2? { background : "rgba(248, 248, 248, 0.50)" }:{ background : "#FFFFFF" }}>
                                        <TableCell align="left">{client.personalDetails?.name || ''}</TableCell>
                                        <TableCell align="left">{client.personalDetails?.surname || ''}</TableCell>
                                        <TableCell align="left">{client.skills?.skill || ''}</TableCell>
                                        <TableCell align="left">{client.employment?.companyName || ''}</TableCell>
                                        <TableCell align="left">{client.employment?.webtonicProject || ''}</TableCell>
                                        <TableCell align="center">{client.employment?.startDate || ''}</TableCell>
                                        <TableCell align="center">{client.employment?.endDate || ''}</TableCell>
                                        <TableCell align="center">
                                            <div>
                                                <Button align="left" variant="text" data-testid='buttonPress' onClick={(event) => handleClick(event, client)} style={{ color: 'black'}}>
                                                    <MoreVertOutlinedIcon />
                                                </Button>
                                                <Popover id={id} open={open} anchorEl={anchorEl} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} elevation={1}  >
                                                    <Typography sx={ typographyStyles }>
                                                        <Button href="/StaffMemberListView" sx={buttonStyles}>View Staff Member</Button>
                                                    </Typography>
                                                    <Typography sx={ typographyStyles }>
                                                        <Button href={`/MyCV?cvId=${CV.id}`} onClick={exportCV} sx={buttonStyles}>Edit</Button>
                                                    </Typography>
                                                </Popover>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
                <Button href="/MyCV" style={{
                    float: "right",
                    backgroundColor: '#EC8D2B',
                    width: '89px',
                    marginTop:'10px',
                    height: '40px',
                    fontFamily: 'Poppins',
                    color: '#FFFFFF',}}
                >ADD CV</Button>
            </div>
        </div>
    );
};
export default StaffMemberListView;